// extracted by mini-css-extract-plugin
export default {"list":"notes_list__aJqIW"};